import { Component, OnInit } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import { LibraryItem, LibraryService } from 'src/app/Services/library.service';
import { ToastrService } from 'ngx-toastr';

export interface LibraryImportModalItem {
  name: string;
  description: string;
  sourceOrganizationName: string;
  compositeKey: string;
}

@Component({
    selector: 'app-library-import-modal',
    templateUrl: './library-import-modal.component.html',
    styleUrls: ['./library-import-modal.component.scss'],
    standalone: false
})
export class LibraryImportModalComponent extends SimpleModalComponent<{ ApiUrl: string, CacheKey: string, Title?: string, Subtitle?: string }, string[] | null> implements OnInit {

  public ApiUrl: string = '';
  public CacheKey: string = '';
  public Title: string = 'Import from Library';
  public Subtitle: string = '';
  public Loading: boolean = false;
  public Search: string = '';
  public Items: LibraryImportModalItem[] = [];
  public SelectedCompositeKeys: Set<string> = new Set<string>();

  constructor(private libraryService: LibraryService, private toastr: ToastrService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    if (!this.ApiUrl) {
      this.toastr.error('Library import modal misconfigured (missing ApiUrl).');
      this.close();
      return;
    }
    if (!this.CacheKey) {
      this.toastr.error('Library import modal misconfigured (missing CacheKey).');
      this.close();
      return;
    }
    await this.Refresh();
  }

  public async Refresh(): Promise<void> {
    this.Loading = true;
    try {
      await this.libraryService.getLibraryItems(this.ApiUrl, this.CacheKey);
      const cached = this.libraryService.getCachedLibraryItems(this.CacheKey);

      this.Items = (cached ?? []).map((r: LibraryItem) => ({
        name: r.name ?? '',
        description: r.description ?? '',
        sourceOrganizationName: r.sourceOrganizationName ?? '',
        compositeKey: r.compositeKey ?? ''
      }));
    }
    catch (e: any) {
      this.toastr.error('Failed to load library items');
      console.error(e);
    }
    finally {
      this.Loading = false;
    }
  }

  public get FilteredItems(): LibraryImportModalItem[] {
    const q = (this.Search ?? '').trim().toLowerCase();
    if (q === '') return this.Items ?? [];

    return (this.Items ?? []).filter(i =>
      (i.name ?? '').toLowerCase().includes(q) ||
      (i.description ?? '').toLowerCase().includes(q) ||
      (i.sourceOrganizationName ?? '').toLowerCase().includes(q) ||
      (i.compositeKey ?? '').toLowerCase().includes(q)
    );
  }

  public isSelected(item: LibraryImportModalItem): boolean {
    return this.SelectedCompositeKeys.has(item.compositeKey);
  }

  public toggleSelected(item: LibraryImportModalItem): void {
    if (!item?.compositeKey) return;
    if (this.SelectedCompositeKeys.has(item.compositeKey)) this.SelectedCompositeKeys.delete(item.compositeKey);
    else this.SelectedCompositeKeys.add(item.compositeKey);
  }

  public cancel(): void {
    this.result = null;
    this.close();
  }

  public confirm(): void {
    const keys = Array.from(this.SelectedCompositeKeys.values());
    this.result = keys;
    this.close();
  }
}


